import { IoCloseSharp } from "react-icons/io5";
import styled from "styled-components";

export default styled(IoCloseSharp)`
    color: #000;
    font-size: 1.4rem;
    opacity: .5;
`;
